import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuTraces = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 16",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M17.29.5a.71.71 0 0 1 0 1.43H.7A.71.71 0 0 1 .71.5H17.3ZM17.29 3.9a.71.71 0 0 1 0 1.42H.7a.71.71 0 0 1 0-1.43H17.3ZM8.65 7.29a.71.71 0 0 1 0 1.42H.7a.71.71 0 1 1 0-1.42h7.94ZM17.29 14.07a.71.71 0 0 1 0 1.43h-4.57a.71.71 0 0 1 0-1.43h4.57ZM14.31 10.65a.71.71 0 1 1 0 1.42H7.71a.71.71 0 0 1 0-1.42h6.6Z",
	fill: "#434343"
}));
const ForwardRef = forwardRef(SvgMainMenuTraces);
export default ForwardRef;
